import { z } from 'zod'

export const StudentAwardPreviewSchema = z.object({
  student_id: z.number(),
  base_amount: z.number(),
  modifier_amount: z.number(),
  total_amount: z.number(),
  error: z.string().nullable().optional(),
})

export const StudentAwardPreviewResultSchema = z.object({
  program_id: z.number(),
  program_purse_id: z.number(),
  total_students_requested: z.number(),
  total_planned_amount: z.number(),
  student_awards: z.array(StudentAwardPreviewSchema),
})

export type StudentAwardPreview = z.infer<typeof StudentAwardPreviewSchema>
export type StudentAwardPreviewResult = z.infer<
  typeof StudentAwardPreviewResultSchema
>
